import { render, staticRenderFns } from "./FolderQuestionValidationDialog.vue?vue&type=template&id=4a41a040&scoped=true"
import script from "./FolderQuestionValidationDialog.vue?vue&type=script&lang=js"
export * from "./FolderQuestionValidationDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderQuestionValidationDialog.vue?vue&type=style&index=0&id=4a41a040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a41a040",
  null
  
)

export default component.exports